import React, { useEffect, useState } from 'react';

import classNames from 'classnames';

import { sortWeekdayValues } from '../CronGenerator/utils/cron-utils';

import { DAYS_OF_THE_WEEK } from '../../constants/cron.constants';

const WeekdaySelectionButton = ({
  value,
  onClick,
  isSelected = false,
}) => (
  <button
    type="button"
    className={classNames(
      'h-12',
      { 'bg-brand text-white': isSelected },
      { 'text-brand': !isSelected },
    )}
    onClick={() => onClick(value)}
  >
    {value}
  </button>
)

const WeekdaySelectionGrid = ({
  values = [],
  onValuesSelected = () => {},
}) => {
  const [selectedValues, setSelectedValues] = useState(values);

  const handleWeekdayButtonClick = (value) => {
    if (selectedValues.includes(value)) {
      const newSelectedValues = selectedValues.filter(curr => curr !== value);

      setSelectedValues(newSelectedValues)
      onValuesSelected(newSelectedValues)
    } else {
      const newSelectedValues = sortWeekdayValues([...selectedValues, value]);

      setSelectedValues(newSelectedValues)
      onValuesSelected(newSelectedValues)
    }
  }

  useEffect(() => {
    onValuesSelected(selectedValues);
  }, [onValuesSelected, selectedValues])

  return (
    <div className="grid grid-cols-7">
      {
        DAYS_OF_THE_WEEK.map(weekdayVal => (
          <WeekdaySelectionButton
            key={`weekday-selection-${weekdayVal}`}
            value={weekdayVal}
            onClick={handleWeekdayButtonClick}
            isSelected={selectedValues.includes(weekdayVal)}
          />
        ))
      }
    </div>
  )
}

export default WeekdaySelectionGrid;
